module.exports = __webpack_public_path__ + "static/media/pasta.67ac6ff9.png";